import { useLazyQuery,gql } from "@apollo/client";
import {GET_PRODUCT_ANSWER_LIST} from "../../constants/product-questions/getProductAnswerConst"
import {useDispatch} from "react-redux"

const GET_PRODUCT_ANSWER=gql`
query GetProductAnswer($page: Int, $limit: Int, $orderId: Int, $token: String) {
  getProductAnswer(page: $page, limit: $limit, orderId: $orderId, token: $token) {
    success
    message
    data {
      questionData {
        questionId
        answer
        doc_url
        backUrl
      }
      totalCount
      totalPage
      isAllQuestionAnswered
      isClientIdUploaded
    }
  }
}
`;

var page;
export const GetProductAnswerAction=()=>{
  const dispatch=useDispatch()
    const [getProductAnswerResponseFunction,
    getProductAnswerResponseData]=useLazyQuery(GET_PRODUCT_ANSWER,{
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-and-network",
        onCompleted:({getProductAnswer:responseData})=>{
          dispatch({
            type:GET_PRODUCT_ANSWER_LIST,
            success :  responseData?.success,
            payload:responseData?.data,
            success :  responseData?.success,
            page
          })
            if(responseData.success){
             }else{

             }
        }
    })

    const getProductAnswerQueryData=getProductAnswerResponseData;

    const initGetProductAnswerData=(data)=>{
            getProductAnswerResponseFunction({
                variables:data
            })
    }
    return {getProductAnswerQueryData,initGetProductAnswerData}
}